<div class="bg_image">
    <div class="row">
        <div class="col-md-6 mt-5">
            <img src="assets\img\background\NBR_logo.jpg" class="nbr_logo">
        </div>
        <!-- <div class="col-md-6 mt-4">
            <img src="assets\img\logo\mujib_borsho.svg" class="mujib100_logo">
        </div> -->
    </div>
    <div class="container">
        <div class="main_section">
            <div class="row">
                <div class="col-6" style="padding-left: 0;">
                    <div *ngFor="let language of languageList" class="float-left">
                        <button (click)="languageClick(language.code)" [class.activeLan]="getSelectedLanguagesCode()===language.code"
                            class="btn btn-sm btn-outline-dark mr-2">{{language.label}}</button>
                    </div>
                </div>
                <div class="col-6 p-0">
                    <label class="label float-right custom mt-2"><b>{{content('eReturn FAQs')}}</b></label>
                </div>
            </div>
        </div>

        <!--------------------------------------------------------- PART 1 FAQ----------------------------------------------------------------------->
        <div class="row mt-4">
            <label class="label fs-title"><b>Part 1 : Basic Information Before Getting Started</b></label>
        </div>
        <div class="row mt-4">
            <label class="label"><b>{{content('Q 1.	Is tax software eReturn easy for beginners?')}}</b></label>
        </div>
        <div class="row">
            <label class="label"><b>{{content('Answer')}} : </b>{{content('If you want to do your own taxes, eReturn system is the way to go. Tax software programs are for taxpayers who want to do their own taxes but need guidance. National Board of Revenue (NBR) developed eReturn system for online tax return submission and made a User Manual for guidance, you can download the user manual from the system. The system is very easy to use and no need to know about tax calculation, software will guide you through the whole process and calculate your tax.')}}</label>
        </div>

        <div class="row mt-4">
            <label class="label"><b>{{content('Q 2.	Who needs a tax software program?')}}</b></label>
        </div>
        <div class="row">
            <label class="label"><b>{{content('Answer')}} : </b>{{content('Anyone can benefit from tax software program. If you don’t want to pay professional tax preparers charge, eReturn software is the next best thing. Nowadays many taxpayers by using tax software (eReturn) versus a professional tax preparer.')}}</label>
        </div>

        <div class="row mt-4">
            <label class="label"><b>{{content('Q 3.	I want to submit return through online, how I will start?')}}</b></label>
        </div>
        <div class="row">
            <label class="label"><b>{{content('Answer')}} : </b>{{content('Before entering the eReturn system you need to know about some important things as follows:')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('1.	You will need a biometrically verified mobile phone number and eTIN number for using eReturn. If there is no TIN, then TIN number should be taken from eTIN option of this software.')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('2.	For best experience and performance, use a laptop or a desktop computer. Mobile devices may not display all features.')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('3.	Keep all necessary documents (Salary certificate, Investment (Sanchayapatra, FDR, DPS, Life insurance etc.), Bank statement, Flat, land information etc.) with you when using eReturn. You will need to enter much information from your documents.')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('4.	You do not need to attach any documents. Just fill in relevant fields and keep related documents with you for any future reference.')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('5.	All computations in eReturn will be based on your inputs and will be suggestive figures. You have the option to edit any system calculation if your own calculations differ.')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('6.	If you have any source tax or advance tax payment, online filing may not provide credit at this moment (development of verification process is ongoing). However, you can prepare your paper return using eReturn system, in that case, e-return can be prepared and printed and submitted to the tax office.')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('7.	When preparing return, you can use system help by putting cursor on (?) sign, detailed guideline from User Manual and finally direct calling to Call center.')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('8.	If you are ready with TIN,your own mobile number, all necessary documents and eReturn User Manual (download user manual from eReturn system), then log on to http://etaxnbr.gov.bd/ .Even then, if there is any difficulty in understanding, call NBR’s Call Center and get the information you need. ')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('9.')}}	<b style="color:#E41B1E;">{{content('Very important:')}}</b> {{content('If you try to Register with someone else’s mobile number other than your own, you will not be able to register with your TIN, and your TIN will be blocked. ')}}</label>
        </div>

        <div class="row mt-2">
            <label class="label"><b>{{content('Q 4.	How can I attach supporting documents?')}}</b></label>
        </div>
        <div class="row">
            <label class="label"><b>{{content('Answer')}} : </b>{{content('You do not need to attach any documents. Just fill in relevant fields. Just this will do. Your assessment will be completed in system, and you will instantly get system generated acknowledgment slip. You may also print tax certificate and a copy of your return by clicking Tax Records menu at the left of the home page of eReturn system.')}}</label>
        </div>
        <div class="row mt-2">
            <label class="label"><b>{{content('Q 5.	Can I use mobile device for eReturn?')}}</b></label>
        </div>
        <div class="row">
            <label class="label"><b>{{content('Answer')}} : </b>{{content('For best experience and performance, use a laptop or a desktop computer. Mobile devices may not display all user-friendly features.')}}</label>
        </div>

        <div class="row mt-2">
            <label class="label"><b>{{content('Q 6.	I no longer use the phone number that was used at the time of TIN registration. Will it be a problem?')}}</b></label>
        </div>
        <div class="row">
            <label class="label"><b>{{content('Answer')}} : </b>{{content('Not at all. Just use your present biometrically verified phone number.')}}</label>
        </div>
        
        <div class="row mt-4">
            <label class="label"><b>{{content('Q 7.	Is there any password rule?')}}</b></label>
        </div>
        <div class="row">
            <label class="label"><b>{{content('Answer')}} : </b>{{content('Yes. Your password will be minimum 8 characters, having at least 1 lower case character, 1 upper case character, 1 digit and 1 special character (such as @, #, %. & and &). When using a laptop or a desktop computer, you will find password checker.')}}</label>
        </div>

        <div class="row mt-4">
            <label class="label"><b>{{content('Q 8.	What I need for registration?')}}</b></label>
        </div>
        <div class="row">
            <label class="label"><b>{{content('Answer')}} : </b>{{content('For registration, your will need a biometrically verified phone number. To know whether your phone number is biometrically verified or not, you may dial *16001# from your phone.')}}</label>
        </div>

        <div class="row mt-4">
            <label class="label"><b>{{content('Q 9.	Do I need to present support documents to tax office for getting my assessment done?')}}</b></label>
        </div>
        <div class="row">
            <label class="label"><b>{{content('Answer')}} : </b>{{content('No. You do not need. Your assessment will be completed in system as soon as you make online submission of your return.')}}</label>
        </div>
    
          <!--------------------------------------------------------- PART 2 FAQ----------------------------------------------------------------------->
          <div class="row mt-4 fs-title">
            <label class="label"><b>Part 2: After Entering the eReturn system</b></label>
        </div>
        <div class="row mt-4">
            <label class="label"><b>{{content('Q 10.	I have entered into etaxnbr.gov.bd, but how will I start?')}}</b></label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('For starting the eReturn system please follow the steps:')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('1.	You need to Register first. Go to https://etaxnbr.gov.bd/')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('2.	Click on Registration button and then system will guide you to proceed. For registration you need your TIN and Mobile Number.')}}</label>
        </div>
        <div class="row">
            <label class="label sub-row">{{content('3.	After completing Registration Click on Sign in button on the screen and proceed. In sign in process your will set your Password, with this password you will log in into the eReturn system.')}}</label>
        </div>
    
        <div class="row mt-2">
            <label class="label"><b>{{content('Q 11.	How can I sign in eReturn?')}}</b></label>
        </div>
        <div class="row">
            <label class="label"><b>{{content('Answer')}} : </b>{{content('You will need your TIN and Password for Sign in. You will set your own Password at the time of registration and can sign in any time using your TIN and password.  ')}}</label>
        </div>
        
  <!--------------------------------------------------------- PART 3 FAQ----------------------------------------------------------------------->
  <div class="row mt-4 fs-title">
    <label class="label"><b>Part 3: After Sign in into eReturn System</b></label>
</div>
<div class="row mt-4">
    <label class="label"><b>{{content('Q 12.	I have logged in into eReturn system, how to start Return Submission process?')}}</b></label>
</div>
<div class="row">
    <label class="label">{{content('To start return submission process follow the steps below:')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('1.	After entering etaxnbr.gov.bd you will see a software screen, which screen shows four (4) menus left side of the screen as Home, Return Submission, Tax Record and Time Extension.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('2.	From that screen click on Return Submission menu. Then system will show another screen showing Assessment Information and Heads of Income,')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('3.	Then proceed on step by step and software will guide you, if any difficulties to understand any term please first follow the User Manual and even then, if it is difficult to understand call the Call Center.')}}</label>
</div>

<div class="row mt-2">
    <label class="label"><b>{{content('Q 13.	May I know briefly about the return submission process?')}}</b></label>
</div>
<div class="row">
    <label class="label"><b>{{content('Answer')}} : </b>{{content('Actually, there are 7 steps in Return submission process, those are as below:')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('1.	Assessment- First you have to put some Basic information:')}}</label>
</div>
<div class="row">
    <label class="label sub-sub-row">{{content('a.	Assessment information- Assessment Year, Income Year etc.')}}</label>
</div>
<div class="row">
    <label class="label sub-sub-row">{{content('b.	Heads of income- Salaries, Interest on Securities, Income from House Property, Agricultural Income, Income from Business or Profession, Capital Gains are the main six (6) head of income.')}}</label>
</div>
<div class="row">
    <label class="label sub-sub-row">{{content('c.	Additional Information- Location of Main Source of Income and others.')}}</label>
</div>
<div class="row">
    <label class="label sub-sub-row">{{content('d.	IT10B Requirements- Assets related information like Gross Wealth, Motor Car')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('2.	Income- In the assessment year give all information of Income, say income from salary, Sanchayapatra, DPS, FDR etc.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('3.	Rebate -Get Rebate from your Investment. Say, investment in the sector of Life insurance, DPS, Sanchayapatra etc.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('4.	Expenditure- Put all information related to your Lifestyle and Tax related Expense. Example of expenses are Expenses for Food, Clothing and Other Essentials, Accommodation Expense, Children’s Education Expenses, Payment of Tax at Source.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('5.	Assets & Liabilities- Detailed information about Assets and Liabilities. Such as: Business capital, non-Agricultural property, Agricultural property, financial assets (Share, Debenture, Savings certificate, FDR, DPS), Motor car, Gold, Diamond, Household item, Cash etc. are the example of Asset. Outside business Loan is Liability.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('6.	Tax and Payment- In this section system will show particulars of Total Income, Particulars of Tax Computation, Tax payable amount. From this section you can submit return by online and you can download or print the offline return.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('7.	Return View- Here software will show the complete Return, you can check if there are any wrong information you entered. ')}}</label>
</div>

<div class="row mt-4">
    <label class="label"><b>{{content('Q 14.	I have paid source tax (and/or advance tax). Can I use eReturn?')}}</b></label>
</div>
<div class="row">
    <label class="label"><b>{{content('Answer')}} : </b>{{content('You can prepare your paper return using eReturn system, make a print copy and submit in the tax office. Online verification of source tax and advance tax requires a number of APIs. The process is ongoing. Online filing option for taxpayers, who paid source tax/advance tax, will be opened gradually.')}}</label>
</div>

<div class="row mt-4">
    <label class="label"><b>{{content('Q 15.	If I need to pay any tax with return, can I make online payment?')}}</b></label>
</div>
<div class="row">
    <label class="label"><b>{{content('Answer')}} : </b>{{content('Yes, you can make online payment using eReturn system at the time of filing online return. How to pay using eReturn system, see the user manual Chapter-6, Tax & Payment.')}}</label>
</div>

 <!--------------------------------------------------------- PART 4 FAQ----------------------------------------------------------------------->
 <div class="row mt-4 fs-title">
    <label class="label"><b>Part 4: Tax Records</b></label>
</div>
<div class="row mt-4">
    <label class="label"><b>{{content('Q 16.	What are the benefits of submitting returns in eReturn system?')}}</b></label>
</div>
<div class="row">
    <label class="label"><b>{{content('Answer')}} : </b>{{content('After submitting return by eReturn system you will get instantly some benefits, which are as follows:')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('1.	You will get TIN certificate from the eReturn system in pdf format.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('2.	Tax certificate is important document for you, eReturn system will provide you the Tax certificate from the eReturn system in pdf format.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('3.	Proof of submitting return named Acknowledge, you will get the acknowledge slip by download from eReturn system.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('4.	If anyone ask to proof through online whether you are submitted return by eReturn system or not, software will generate a link, by clicking on that link anyone can see the proof of submission of return called Verification Slip.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('5.	You will get Return document from the eReturn system, you can download or print from the eReturn system.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('6.	Challan copy will be generated by the eReturn system.')}}</label>
</div>
<div class="row">
    <label class="label sub-row">{{content('7.	All kind of Tax related History you will get from the eReturn system.')}}</label>
</div>

<!--------------------------------------------------------- PART 5 FAQ----------------------------------------------------------------------->
<!-- <div class="row mt-4 fs-title">
    <label class="label"><b>Part 5: Time Extension</b></label>
</div>
<div class="row mt-4">
    <label class="label"><b>{{content('Q 17.	I have not been able to submit the return within the stipulated time, what should I do to submit it online eReturn system?')}}</b></label>
</div>
<div class="row">
    <label class="label"><b>{{content('Answer')}} : </b>{{content('In the eReturn system there is a menu named Time Extension, with this option you can apply for time extension with valid reason.')}}</label>
</div>
<div class="row mt-4">
    <label class="label"><b>{{content('Q 18.	If the return is submitted after the prescribed time, will the tax rebate be less?')}}</b></label>
</div>
<div class="row">
    <label class="label"><b>{{content('Answer')}} : </b>{{content('After applying for extension of time, the rebate will be reduced by 50% if the return is filed within the extended period. So, getting rebate 100% try to submit return within the prescribed time.')}}</label>
</div> -->






    </div>
    <div class="row mt-3">
        <div class="col-12">
            <button type="button" class="btn btn-sm backBtn mb-3" (click)="onBacktoMainPage()">
                <svg style="font-size: 20px;" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-left"
                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                </svg>&nbsp;
                Back &nbsp;&nbsp;&nbsp;</button>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>